import { init } from '@rematch/core';
import selectPlugin from '@rematch/select';
// import loadingPlugin from '@rematch/loading';
import auth from './auth';
import tree from './tree';
// eslint-disable-next-line import/no-cycle
import lists from './lists';

import miningAndPumping from './mining-and-pumping';
import summaryMode from './mining-and-pumping/summary-mode';
import developmentIndicators from './mining-and-pumping/summary-mode/development-indicators';
import comparisonOdPeriods from './mining-and-pumping/summary-mode/comparison-of-periods';
import approximation from './mining-and-pumping/summary-mode/approximation';
import consolidatedProduction from './mining-and-pumping/summary-mode/consolidated-production';

import gtm from './mining-and-pumping/gtm';
import chartsWidget from './mining-and-pumping/charts-widget';
import tableWidget from './mining-and-pumping/table-widget';
import miniMapWidget from './mining-and-pumping/mini-map-widget';
import gtmEfficiency from './gtm-efficiency';
import factorAnalysis from './factor-analysis';
import oilProductionLoss from './oil-production-loss';
import versions from './versions';
import tablets from './well-logs/tablets/index';
import inspector from './well-logs/inspector';
import settings from './well-logs/settings/settings';
import settingsSidebar from './well-logs/settings/sidebar';
import settingsResearch from './well-logs/settings/research';
import { stratigraphyModel } from './well-logs/stratigraphy';
import { innkModel } from './well-logs/innk';
import { techModel } from './well-logs/tech';
import { oilGasOccurrencesModel } from './well-logs/oilgas';
import { thicknessInterlayerModel } from './well-logs/thicknessInterlayer';
import displayTabletMode from './well-logs/displayTabletMode';
import reports from './reports';
import treeReports from './reports/tree';
import { filterReportModel } from './reports/filters';
import desaturationCharacteristics from './desaturation-characteristics';
import runner from './well-logs/runner';
import { tabletObjectsModel } from './well-logs/tabletObjects';
import { inclinometry, inclinometryModal } from './well-logs/inclinometry';
import { pgiWellModel } from './well-logs/pgi';
import { rigisResidueModel } from './well-logs/rigisResidue';
import { gisReportModel } from './well-logs/gisReport';
import { rappersModel } from './well-logs/rappers';
import { coreReportModel } from './well-logs/coreReport';
import { wellsRappersModel } from './well-logs/rappers/wellsRappers';
import { infoReportsModel } from './reports/info';
import { templatesModel } from './well-logs/templates';
import { templateWellsModel } from './well-logs/templates/templateWells';
import { displaySettingsModel } from './display-settings';
import { grpWellModel } from './well-logs/grp';
import { gdiWellModel } from './well-logs/gdi';
import { faceWellModel } from './well-logs/face';
import { offsetWellModel } from './well-logs/offsets';
import { offsetVersionsModel } from './well-logs/offsets/versions';
import { baseFilterReportModel } from './reports/filters/base';
import { gdiFilterReportModel } from './reports/filters/gdi';
import { gosplanFilterReportModel } from './reports/filters/gosplan';
import { tabletDrawingModel } from './well-logs/drawing';
import { curvesModel } from './well-logs/curves';
import { curveSettingsModel } from './well-logs/curves/settings';
import { researchesModel } from './well-logs/researches';
import { tabletSettingsModel } from './well-logs/tabletSettings';
import { profilesModel } from './well-logs/profiles';
import { stateWellsModel } from './well-logs/stateWells';
import { merFilterReportModel } from '@/store/reports/filters/mer';
import { techInfoModel } from './reports/tech-info';
import { wellResearchFilterReportModel } from './reports/filters/well-research-filter-report';
import { intervalResearchesModel } from './well-logs/intervalResearches';
import { gdis } from './mining-and-pumping/gdis';
import { tracersModel } from './well-logs/tracers';
import { columnsTooltipProps } from './well-logs';
import { geoTest } from './geo-test';
import newsModel from './news';
import { projectFundModel } from './project-fund';
import { requestBlock } from './reports/requestsBlock';

export const models = {
    auth,
    tree,
    lists,
    miningAndPumping,
    summaryMode,
    developmentIndicators,
    comparisonOdPeriods,
    approximation,
    consolidatedProduction,

    gtm,
    chartsWidget,
    tableWidget,
    miniMapWidget,
    gtmEfficiency,
    factorAnalysis,
    oilProductionLoss,
    settings,
    settingsSidebar,
    settingsResearch,
    versions,
    inspector,
    tablets,
    reports,
    desaturationCharacteristics,
    runner,
    tabletObjectsModel,
    displayTabletMode,
    inclinometry,
    inclinometryModal,
    treeReports,
    filterReport: filterReportModel,
    pgiWell: pgiWellModel,
    rigisResidue: rigisResidueModel,
    gisReport: gisReportModel,
    coreReport: coreReportModel,
    rappers: rappersModel,
    wellsRappers: wellsRappersModel,
    infoReports: infoReportsModel,
    requestsBlock: requestBlock,
    profiles: profilesModel,
    templates: templatesModel,
    templateWells: templateWellsModel,
    grpWell: grpWellModel,
    gdiWell: gdiWellModel,
    faceWell: faceWellModel,
    offsetWell: offsetWellModel,
    offsetVersions: offsetVersionsModel,
    baseFilterReport: baseFilterReportModel,
    gdiFilterReport: gdiFilterReportModel,
    wellResearchFilterReport: wellResearchFilterReportModel,
    gosplanFilterReport: gosplanFilterReportModel,
    merFilterReport: merFilterReportModel,
    techInfo: techInfoModel,
    tabletDrawing: tabletDrawingModel,

    displaySettings: displaySettingsModel,

    curves: curvesModel,
    curveSettings: curveSettingsModel,
    stratigraphy: stratigraphyModel,
    innk: innkModel,
    tracers: tracersModel,
    tech: techModel,
    oilGasOccurrences: oilGasOccurrencesModel,
    thicknessInterlayer: thicknessInterlayerModel,
    researches: researchesModel,
    tabletSettings: tabletSettingsModel,
    stateWells: stateWellsModel,
    intervalResearchesModel: intervalResearchesModel,
    gdis: gdis,
    columnsTooltipProps,
    news: newsModel,
    geoTest,
    projectFund: projectFundModel
};

const store = init({
    models,
    // plugins: [selectPlugin(), loadingPlugin()],
    plugins: [selectPlugin()],
});

export const { select } = store;
export default store;
